<script lang="ts">
  import { Column, Grid, Row } from "carbon-components-svelte";
  import type { ICanvas } from "src/ts/Interfaces";
  import type APIClient from "src/ts/APIClient";
  import Editor from "../editor/Editor.svelte";
  import Preview from "../preview/RubberStamp/Preview.svelte";

  export let canvas: ICanvas;
  export let client: APIClient;
</script>

<Grid noGutter>
  <Row>
    <Column sm={16} md={8} lg={10}>
      <Editor bind:canvas />
    </Column>
    <Column sm={16} md={8} lg={6}>
      <Preview bind:canvas {client} />
    </Column>
  </Row>
</Grid>
